import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { DatePickerInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type ForeignersProps = {
  disabled?: boolean
  skeletonShow?: boolean
}

export function Foreigners({ disabled, skeletonShow }: ForeignersProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('for foreign citizens')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <DatePickerInput
            label='form.registration date'
            placeholder='form.enter registration date'
            name='data.registrationDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            label='form.enter registration expiration date'
            placeholder='form.enter registration expiration date'
            name='data.registrationExpirationDate'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
